// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28Pc8","questions":"styles_questions__1s18V","footer":"styles_footer__3fw-M"};